(() => {
  if (window.HermexAvailability) return;
  window.HermexAvailability = {
    resolve(data, quantity = 1) {
      const requested = Math.max(1, Number(quantity) || 1);
      const status = requested > data.stock ? data.overflow : data.normal;
      return {
        ...status,
        text: status.text.replace('__HX_BACKORDER__', String(Math.max(0, requested - data.stock))),
        maxQuantity: data.maxQuantity,
        blocked: data.blocked
      };
    }
  };
})();

if (!customElements.get('hx-inventory-status')) {
  customElements.define('hx-inventory-status', class extends HTMLElement {
    connectedCallback() {
      this.timer = setTimeout(() => this.init(), 0);
    }
    init() {
      const json = this.querySelector('[type="application/json"]');
      if (!json || !this.isConnected) return;
      this.states = JSON.parse(json.textContent);
      this.scope = this.closest('.js-product') || this.closest('.shopify-section') || document;
      this.variantId = this.dataset.variantId;
      this.handler = (event) => {
        if (event.type === 'on:variant:change') {
          this.variantId = event.detail?.variant?.id ? String(event.detail.variant.id) : null;
          this.update();
        } else {
          const input = this.scope.querySelector('form[action*="/cart/add"] [name="id"]');
          if (input) this.variantId = input.value;
          this.update();
        }
      };
      ['on:variant:change', 'change', 'input'].forEach(name => this.scope.addEventListener(name, this.handler));
      this.update();
    }
    update() {
      const data = this.states[this.variantId];
      this.hidden = !data;
      if (!data) return;
      const inputs = [...this.scope.querySelectorAll('form[action*="/cart/add"] [name="quantity"]')];
      const input = inputs.find(el => el.offsetParent !== null) || inputs[0];
      const state = window.HermexAvailability.resolve(data, input?.value || 1);
      const notice = this.querySelector('.js-inventory-notice');
      notice.textContent = state.text;
      notice.style.color = state.color;
      notice.dataset.inventoryLevel = state.level;
      this.dataset.inventoryLevel = state.level;
      inputs.forEach(el => {
        if (state.maxQuantity !== null) {
          el.max = String(state.maxQuantity);
          el.dataset.hxStockMax = 'true';
          if (state.maxQuantity > 0 && Number(el.value) > state.maxQuantity) el.value = String(state.maxQuantity);
        } else if (el.dataset.hxStockMax) {
          el.removeAttribute('max');
          delete el.dataset.hxStockMax;
        }
      });
      this.scope.querySelectorAll('form[action*="/cart/add"] button[name="add"]').forEach(button => {
        if (state.blocked) {
          button.disabled = true;
          button.dataset.hxStockBlocked = 'true';
        } else if (button.dataset.hxStockBlocked) {
          button.disabled = false;
          delete button.dataset.hxStockBlocked;
        }
      });
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      if (this.scope && this.handler) ['on:variant:change', 'change', 'input'].forEach(name => this.scope.removeEventListener(name, this.handler));
    }
  });
}
